/*
  Based on Mass PFML Footer
*/

import routes from 'src/routes';

import { useTranslations } from 'next-intl';
import React from 'react';

import CustomLink from 'src/components/CustomLink';
import MayflowerIcon from './MayflowerIcon';
import SiteLogo from './SiteLogo';

/**
 * Global page footer, displayed at the bottom of every page.
 */
const Footer = () => {
  const t = useTranslations('components.Footer');

  const contact = [
    {
      icon: <MayflowerIcon name="questionMark" width="38px" height="38px" />,
      component: (
        <div>
          <CustomLink href={routes.internal.feedback}>{t('feedback')}</CustomLink>
        </div>
      ),
    },
    {
      icon: <MayflowerIcon name="marker" width="38px" height="38px" />,
      component: (
        <span className="ma__address">
          <div className="ma__address__address">{t('org_address')}</div>
        </span>
      ),
    },
    {
      icon: <MayflowerIcon name="phone" width="38px" height="38px" />,
      component: (
        <div className="ma__phone-number">
          {t('mass_211_contact_number')}
          <CustomLink href={`tel:${routes.external.phones.mass_211_contact_number}`}>
            {routes.external.phones.mass_211_contact_number}
          </CustomLink>
        </div>
      ),
    },
    {
      icon: <MayflowerIcon name="globe" width="38px" height="38px" />,
      component: (
        <div>
          <CustomLink href={routes.external.massgov.ccrr_offices}>{t('contact_ccrr_office')}</CustomLink>
        </div>
      ),
    },
  ];
  const today = new Date();
  const year = today.getFullYear();
  const links = [
    {
      href: routes.external.massgov.privacyPolicy,
      external: true,
      title: t('privacy_policy'),
    },
    {
      href: routes.external.massgov.accessibilityStatement,
      external: true,
      title: t('data_sharing_agreement'),
    },
    {
      href: routes.internal.securityPolicy,
      external: false,
      title: t('security'),
    },
  ];

  return (
    <footer className="ma__footer-slim" id="footer">
      <div className="ma__footer-slim_fixed">
        <div className="ma__footer-slim__container ma__container">
          <div className="ma__footer-slim__container__logos ma__footer-slim__container__logos--stacked"></div>
          <div className="ma__footer-slim__container__inner ma__footer-slim__container__inner--stacked">
            <div className="ma__footer-slim__info">
              <SiteLogo
                url={routes.external.massgov.eec}
                image={{
                  src: `${process.env.NEXT_PUBLIC_BASE_PATH}/img/seal_happle.svg`,
                  alt: t('EEC'),
                  width: 128,
                  height: 56,
                }}
                title={t('logo_title_EEC')}
              />
              <div className="ma__footer-slim__title">{t('title')}</div>
              <p>{t('description')}</p>
            </div>
            <div className="ma__footer-slim__details">
              <address className="ma__footer-slim__contact">
                {contact.map((field, i) => (
                  <div className="ma__footer-slim__contact__item" key={`filterbox-field-${i}`}>
                    {React.cloneElement(field.icon, {
                      width: 20,
                      height: 20,
                    })}
                    {field.component}
                  </div>
                ))}
              </address>
            </div>
          </div>
        </div>
        <div className="ma__footer-slim__container ma__container">
          <div className="ma__footer-slim__container__logos ma__footer-slim__container__logos--stacked"></div>
          <div className="ma__footer-slim__container ma__footer-slim__container__inner ma__footer-slim__links">
            {links.map((link, linkIndex) => (
              <React.Fragment key={`footslimlinks-fragment-${linkIndex}`}>
                <CustomLink external={link.external} href={link.href} key={`footslimlinks-${linkIndex}`}>
                  {link.title}
                </CustomLink>
              </React.Fragment>
            ))}
          </div>
        </div>
        <div>
          {/* TODO: Remove inline style with appropriate CSS class when design system is available */}
          <p className="ma__footer-slim__copyright" style={{ marginLeft: '45px' }}>
            &copy; {`${year} Commonwealth of Massachusetts.`}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
